import React from 'react';
import empty from '../../assets/empty.jpg';

const Empty = () => <img src={empty} alt="empty" />;

export default Empty;



// WEBPACK FOOTER //
// ./src/components/common/Empty.js